module.exports = __webpack_public_path__ + "img/playback_icon.ea09c7d4.png";